import { parseMoneyAmountSR, getArchivedJobLocalDayKey } from './displayUtils';
import { getWorkerName } from './workerUtils';

/** U konzoli: localStorage.setItem('spinTaskerPeriodDebug','1') pa refresh. Isključi: '0'. */
export const PERIOD_DEBUG_LS_KEY = 'spinTaskerPeriodDebug';

export function isPeriodDebugEnabled() {
  return typeof window !== 'undefined' && localStorage.getItem(PERIOD_DEBUG_LS_KEY) === '1';
}

/** Ista logika kao pojedinačni posao u JobAnalyticsView.calculateStatistics */
function jobNetProfitFromReport(job) {
  if (!job.report) return 0;
  const revenue = parseMoneyAmountSR(job.report.serviceCharged);

  let reversiCost = job.report.reversiCost || 0;
  if (
    reversiCost === 0 &&
    job.report.usedSpareParts &&
    Array.isArray(job.report.usedSpareParts)
  ) {
    reversiCost = job.report.usedSpareParts.reduce((sum, part) => {
      if (!part) return sum;
      const price = typeof part.price === 'number' ? part.price : parseFloat(part.price) || 0;
      const quantity =
        typeof part.quantity === 'number' ? part.quantity : parseFloat(part.quantity) || 1;
      return sum + price * quantity;
    }, 0);
  }

  let additionalMaterialsCost = job.report.additionalMaterialsCost || 0;
  if (
    additionalMaterialsCost === 0 &&
    job.report.additionalMaterials &&
    Array.isArray(job.report.additionalMaterials)
  ) {
    additionalMaterialsCost = job.report.additionalMaterials.reduce((sum, material) => {
      if (!material) return sum;
      const price = typeof material.price === 'number' ? material.price : parseFloat(material.price) || 0;
      return sum + price;
    }, 0);
  }

  const amortizationCost = job.report.amortizationCost || 0;
  const totalCost = reversiCost + additionalMaterialsCost + amortizationCost;

  if (job.report.profit != null && job.report.profit !== '' && !Number.isNaN(Number(job.report.profit))) {
    return Number(job.report.profit);
  }
  return revenue - totalCost;
}

/**
 * Loguje tabelu poslova za poređenje Arhiva vs Analitika (isti format).
 * Poziva se samo ako je startDate i endDate postavljen i spinTaskerPeriodDebug=1.
 */
export function logPeriodJobsTable(sectionLabel, jobs, ctx = {}) {
  if (!isPeriodDebugEnabled()) return;

  const { startDate, endDate, selectedWorker, selectedPartner, workers = [], partners = [], extra = {} } =
    ctx;

  if (!startDate || !endDate) {
    return;
  }

  const rows = jobs.map((job) => {
    const naplataNum = job.report ? parseMoneyAmountSR(job.report.serviceCharged) : 0;
    const cista = jobNetProfitFromReport(job);
    return {
      id: String(job._id || '').slice(-8),
      kalendarDan: getArchivedJobLocalDayKey(job) || '-',
      radnik: getWorkerName(job.assignedTo, workers, partners),
      status: job.status,
      naplataRaw: job.report?.serviceCharged ?? '-',
      naplata: naplataNum,
      cistaZarada: Math.round(cista * 100) / 100,
      profitUReportu: job.report?.profit ?? '-'
    };
  });

  const sumNaplata = rows.reduce((s, r) => s + r.naplata, 0);
  const sumCista = rows.reduce((s, r) => s + (Number.isFinite(r.cistaZarada) ? r.cistaZarada : 0), 0);

  console.groupCollapsed(
    `${sectionLabel} | poslova: ${jobs.length} | Σ naplata: ${sumNaplata.toLocaleString('sr-RS')} RSD | Σ čista zarada: ${sumCista.toLocaleString('sr-RS')} RSD`
  );
  console.log('Period (od–do):', { startDate, endDate });
  console.log('Filteri:', {
    radnik: selectedWorker ?? 'all',
    partner: selectedPartner ?? 'all',
    ...extra
  });
  console.log(
    `Debug: localStorage.setItem("${PERIOD_DEBUG_LS_KEY}","1") ili "0" — pa refresh stranice.`
  );
  console.table(rows);
  console.groupEnd();
}
